export const TOAST = {
  DEFAULT: 'default-toast',
  SUCCESS: 'success-toast',
  ERROR: 'error-toast',
  INFO: 'info-toast',
  WARNING: 'warning-toast',
  LOADING: 'loading-toast'
} as const;
